const Title = ({title, degree}: ITitleProps) => {
  return (
    <>
      <div className="flex mt-5 mb-5">
        <p className=" text-gray-6 font-extrabold ml-2">{title}</p>
        {degree && (
          <div className=" px-2  rounded-2xl bg-orange-4">
            <p className=" text-primary text-sm">{degree}</p>
          </div>
        )}
      </div>
    </>
  );
};

export default Title;
